import { render, staticRenderFns } from "./OrgChartNodeEditor.vue?vue&type=template&id=33d7d1bc&"
import script from "./OrgChartNodeEditor.vue?vue&type=script&lang=js&"
export * from "./OrgChartNodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports